<template>
  <div>
    <vs-alert title="Informasi" class="my-5 mb-5" color="warning">
      Data yang tersaji pada halaman statistik ini berasal dari data kunjungan masyarakat ke MPP Kabupaten Badung yang tercatat dan diproses secara digital / elektronik melalui
      <strong> <a href="https://mpp.badungkab.go.id">Sistem Informasi Pelayanan Publik MPP Kab. Badung.</a></strong>
    </vs-alert>
    <VisitorRecapSection />
    <div class="vx-row mb-base">
      <visitor-by-instancy />
    </div>
    <div class="vx-row mb-base">
      <visitor-by-services />
    </div>
    <div class="vx-row">
      <services-by-instancy />
    </div>
  </div>
</template>

<script>
import ServicesByInstancy from './components/ServicesByInstancy.vue'
import VisitorByInstancy from './components/VisitorByInstancy.vue'
import VisitorByServices from './components/VisitorByServices.vue'
import VisitorRecapSection from './components/VisitorRecapSection.vue'
import TopInstancy from './components/TopInstancy.vue'

export default {
  components: {
    ServicesByInstancy,
    VisitorByInstancy,
    VisitorByServices,
    VisitorRecapSection, 
    TopInstancy
  },
}
</script>
